export const button = {
    en: {
        play: 'Play',
        start_anyway: 'Start anyway',
        next: 'Next',
        next_round: 'Next round',
        play_again: 'Play again',
        back_to_menu: 'Back to menu',
        guess: 'Guess',
        pass: 'Pass',
        go_all_in: 'Go all-in!',
        trap_triggered: 'Trap is triggered',
        explanation_is_over: 'Explanation is over',
        command_version: 'We have a guess',
        correct: 'Correct',
        incorrect: 'Incorrect',
        submit: 'Submit',
        night: 'Night',
        nextSpeaker: 'Next speaker',
        lastSpeaker: 'Last speaker',
        yes: 'yes',
        no: 'no',
        subscribe: 'subscribe',
        invite_player: 'Invite player',
        copy_link: 'Copy link',
        link_copied: 'Link copied',
    },
    ru: {
        start_anyway: 'Все равно начать',
        next: 'Дальше',
        next_round: 'Следующий раунд',
        play: 'Начать игру',
        play_again: 'Начать заново',
        back_to_menu: 'Перейти в меню',
        guess: 'Версия',
        pass: 'Пас',
        go_all_in: 'Пойти ва-банк!',
        trap_triggered: 'Ловушка сработала',
        explanation_is_over: 'Я закончил объяснять',
        command_version: 'Версия команды',
        correct: 'Верно',
        incorrect: 'Неверно',
        submit: 'Отправить',
        night: 'Ночь',
        nextSpeaker: 'Передать',
        lastSpeaker: 'Закончить',
        yes: 'да',
        no: 'нет',
        subscribe: 'подписаться',
        invite_player: 'пригласить',
        copy_link: 'копировать ссылку',
        link_copied: 'ссылка копирована',
    }
};
